import { apiSlice } from "../../app/api/apiSlice";

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createUser: builder.mutation({
      query: (addNewUserData) => {
        return {
          url: "/register",
          method: "POST",
          body: addNewUserData,
        };
      },
      // Invalidating 'getUsers' query after creating a new user
      invalidatesTags: [{ type: "User", id: "LIST" }],
    }),
    getUsers: builder.query({
      query: () => ({
        url: "/users",
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "User", id })),
              { type: "User", id: "LIST" },
            ]
          : [{ type: "User", id: "LIST" }],
    }),
    editUser: builder.mutation({
      query: (updatedUser) => {
        return {
          url: "users/edit",
          method: "PUT",
          body: updatedUser,
        };
      },
      // Invalidating 'getUsers' query after editing a user
      invalidatesTags: [{ type: "User", id: "LIST" }],
    }),
    getAllGroups: builder.query({
      query: () => ({
        url: "/groups/getallGroup",
        method: "GET",
      }),
    }),
    getSingleUser: builder.query({
      query: (userId) => ({
        url: `users/${userId}`,
        method: "GET",
      }),
    }),
    searchUser: builder.query({
      query: (params) => ({
        url: `users/searchuser`,
        method: "GET",
        params: { query: params },
      }),
    }),
  }),
});

export const {
  useCreateUserMutation,
  useGetUsersQuery,
  useGetAllGroupsQuery,
  useEditUserMutation,
  useGetSingleUserQuery,
  useSearchUserQuery,
} = adminApiSlice;
